// extracted by mini-css-extract-plugin
export default {"Profile":"Profile_Profile__C+cBP"};